import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    getMarketCountLabel,
    getTeamName,
    isEventThisWeek,
    openGamePage,
} from './helper';
import { detectMobile, formatDate } from '../../utils/UiHelper';
import * as UiActions from 'actions/UiActions';
import { UI_INFO_MESSAGE } from 'constants/ui';
import {
    EventColMeta,
    EventColRight,
    EventMainMarkets,
    EventName,
    EventNames,
    EventTime,
    EventTimeCol,
    LinkShowAllMarkets,
    LiveSreamIcon,
    ViewEventListItemBox,
} from './styled';
import ViewMainMarkets from '../../components/ViewMainMarkets/ViewMainMarkets';
import { useContainerWidth } from '../../contexts/ContainerWidthContext';

const PreEventListItem = ({ ev, marketList, header, userId }) => {
    const isMobile = detectMobile();
    const contentWidth = useContainerWidth();
    const marketCountLabel = getMarketCountLabel(ev, isMobile, contentWidth);

    const showInfoNotification = (text, e) => {
        e.preventDefault();
        e.stopPropagation();
        props.uiActions.notification(UI_INFO_MESSAGE, text);
    };

    const isThisWeek = isEventThisWeek(ev.kickoff);
    const dayFormat = isThisWeek ? 'ddd' : 'DD MMM';

    const timeView = (
        <EventTimeCol $isMobile={isMobile}>
            <EventTime $capitalize={isThisWeek}>
                {formatDate(ev.kickoff, dayFormat)}
            </EventTime>
            <EventTime>{formatDate(ev.kickoff, 'HH:mm')}</EventTime>
        </EventTimeCol>
    );

    return (
        <div>
            <ViewEventListItemBox $isMobile={isMobile}>
                <EventColMeta $isMobile={isMobile} $contentWidth={contentWidth}>
                    {!isMobile && timeView}
                    <EventNames
                        onClick={() => openGamePage(ev, userId)}
                        $isMobile={isMobile}
                    >
                        <EventName>
                            {getTeamName(ev, '1')}
                            {marketList[0] &&
                                marketList[0].freeText && (
                                    <i
                                        className="fa fa-info-circle blue cursor-pointer"
                                        aria-hidden="true"
                                        title={marketList[0].freeText}
                                        onClick={(e) => {
                                            showInfoNotification(
                                                marketList[0].freeText,
                                                e
                                            );
                                        }}
                                    />
                                )}
                        </EventName>
                        <EventName>{getTeamName(ev, '2')}</EventName>
                    </EventNames>
                </EventColMeta>

                <EventMainMarkets
                    $isMobile={isMobile}
                    $contentWidth={contentWidth}
                >
                    <ViewMainMarkets
                        market={marketList[0]}
                        ev={ev}
                        live={ev.live ? '1' : '0'}
                        header={header}
                    />
                </EventMainMarkets>

                <EventColRight $isMobile={isMobile}>
                    {isMobile && (
                        <>
                            {timeView}
                            {marketList[0] &&
                                marketList[0].freeText && (
                                    <i
                                        className="fa fa-info-circle blue cursor-pointer"
                                        aria-hidden="true"
                                        title={marketList[0].freeText}
                                        onClick={(e) => {
                                            showInfoNotification(
                                                marketList[0].freeText,
                                                e
                                            );
                                        }}
                                    />
                                )}
                        </>
                    )}
                    <LinkShowAllMarkets
                        onClick={() => openGamePage(ev, userId)}
                        $visible={Boolean(marketCountLabel)}
                        $isMobile={isMobile}
                    >
                        <span>{marketCountLabel}</span>
                    </LinkShowAllMarkets>
                    {!isMobile && (
                        <LiveSreamIcon>
                            <span />
                        </LiveSreamIcon>
                    )}
                </EventColRight>
            </ViewEventListItemBox>
        </div>
    );
};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PreEventListItem);
